"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VentaDevolucionConverterViejo = void 0;
const generarCampoBusqueda_1 = require("../utils/generarCampoBusqueda");
const VentaDevolucionConverterViejo = {
    toFirestore(ventaDevolucion) {
        const obj = ventaDevolucion;
        if (obj.buscablePor != null) {
            obj.query = (0, generarCampoBusqueda_1.generarCampoBusqueda)({ buscableParcialPor: obj.buscablePor, buscableExactoPor: [obj.id] });
        }
        return obj;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            version: data.version,
            id: data.id,
            formaDePago: data.formaDePago,
            fechaComprobante: data.fechaComprobante,
            fechaComprobanteString: data.fechaComprobanteString,
            fechaCreacion: data.fechaCreacion,
            comprobante: data.comprobante,
            serie: data.serie,
            numero: data.numero,
            cliente: data.cliente,
            moneda: data.moneda,
            descuentoGeneral: data.descuentoGeneral,
            ventaLinea: data.ventaLinea,
            tipo: data.tipo,
            subtotal: data.subtotal,
            montoIVA: data.montoIVA,
            total: data.total,
            saldo: data.saldo,
            activo: data.activo,
            observaciones: data.observaciones,
            usuario: data.usuario,
            local: data.local,
            buscablePor: data.buscablePor,
            productos: data.productos,
            tipoDevolucion: data.tipoDevolucion,
            detalleDevolucion: data.detalleDevolucion,
            detalleDevolucionImporte: data.detalleDevolucionImporte,
            cotizacion: data.cotizacion,
            tcfe: data.tcfe,
            cobros: data.cobros,
            cuentaAjena: data.cuentaAjena
        };
    }
};
exports.VentaDevolucionConverterViejo = VentaDevolucionConverterViejo;
